module.exports = __webpack_public_path__ + "img/BIOLOGIA.b0d6cc21.png";